export default __webpack_public_path__ + "ff9f01f4b1b3f38921d57f20db995ccf.png";